import React from 'react'
import classNames from 'classnames'

const TableRow = ({ badge, children, href, productId, className, disabled, preapproved }) => {
  if (preapproved) {
    // we don't want to wrap the whole row in an anchor tag if product row is preapproved
    // as it will cause the whole row to be clickable
    return (
      <div
        className={classNames(
          'TableRow',
          {
            'TableRow--withBadge': badge,
            'TableRow--disabled': !href || disabled,
          },
          className,
        )}
        data-product-id={productId}
      >
        {badge && <div className='TableRow__badge'>{badge}</div>}
        <div className='TableRow__header'>
          You&apos;ve been pre-approved for this card and rate today.{' '}
          <span data-preapproved-click='false'>What does this mean?</span>
        </div>
        <a
          className='TableRow__preapprovedContent'
          href={!disabled && href}
          target='_blank'
          rel='noreferrer noopener nofollow'
        >
          {children}
        </a>
      </div>
    )
  } else {
    return (
      <a
        className={classNames(
          'TableRow',
          {
            'TableRow--withBadge': badge,
            'TableRow--disabled': !href || disabled,
          },
          className,
        )}
        href={!disabled && href}
        data-product-id={productId}
        target='_blank'
        rel='noreferrer noopener nofollow'
      >
        {badge && <div className='TableRow__badge'>{badge}</div>}
        {children}
      </a>
    )
  }
}
export default TableRow
